module.exports = __webpack_public_path__ + "img/744.909c5582.jpg";